import moment from 'moment';

export const mapValuesToConstants = (value) => {
  switch (value) {
    case 'Ideal':
    case 'Solar Only':
    case 'Non-Owner Tenant':
    case 'Rooftop':
    case "I Don't Know":
      return 0;
    case 'Semi-Ideal':
    case 'Solar + Upgrades':
    case 'Property Owner / Owner-User / Partner':
    case 'Warehouse':
    case 'Built-Up Roofing (BUR) Membrane':
    case 'Ground Mount':
    case 'Repairs':
      return 1;
    case 'Typical':
    case 'Employee / Representative of Owner':
    case 'Distribution Center':
    case 'Modified Bitumen':
    case 'Carport':
    case 'Partial Reroof':
      return 2;
    case 'Difficult':
    case 'Heavy Manufacturing':
    case 'Metal Roofing':
    case 'Multiple':
    case 'Full Reroof':
      return 3;
    case 'Retail / Shopping Center':
    case 'EPDM Rubber Membrane':
      return 4;
    case 'School':
      return 5;
    case 'Multi-Family Residential':
      return 6;
    case 'Cold Storage':
      return 7;
    case 'Light Manufacturing':
      return 8;
    case 'Grocery Store':
      return 9;
    case 'Church':
      return 10;
    case 'Commercial Office':
      return 11;
    case 'Resort / Hotel':
      return 12;
    case 'Other / Not Listed':
      return 13;
    case 'General Class A Office':
      return 14;
    case 'Medical Office':
      return 15;
    case 'Community Center':
      return 16;
    case 'Class C Office':
      return 17;
    case 'Sports Complexes / Gyms':
      return 18;
    case 'Parking Garages':
      return 19;
    case 'Hospitals or Nursing Facilities':
      return 20;
    case 'Not-for-profits / Civic Properties':
      return 21;
    case 'Data Center':
      return 22;
    case 'Marinas or County Club':
      return 23;
    case 'Auto Dealerships / Autobody Repair':
      return 24;
    case 'Orchard':
      return 25;
    case 'Yes':
      return true;
    case 'No':
      return false;
    case 'idk':
      return null;
    default:
      break;
  }
};

export const formatRequestDate = (date) => {
  if (date === undefined) {
    return;
  }
  if (date === null) {
    return null;
  }
  return moment(date).format('YYYY-MM-DD');
};

export const formatResponseDate = (date) => {
  if (!date) {
    return 'N/A';
  }
  return moment(date).format('MM-DD-YYYY');
};
